import React, { useEffect, useRef, useState } from "react"
import { Container, Heading, ScrollArea, Spinner } from '@radix-ui/themes'
import useFetch from "../../core/hooks/useFetch"
import PosterService from "../../core/services/PosterService"
import { IPoster } from "../../core/types/services-types/poster-types"
import { ISettings } from "../../core/types/services-types/admin-types"
import AdminService from "../../core/services/AdminService"
import PosterRender from "../../components/common/renders/poster-render"

export default function Vacancy() {

    const [limit, setLimit] = useState(100)
    const [page, setPage] = useState(0)
    const [total, setTotal] = useState(0)
    const [posters, setPosters] = useState<IPoster[]>([])
    const [settingsSite, setSettingsSite] = useState<ISettings>()
 

    const [fetchPosters, isLoading, error, errors] = useFetch(async () => {
      console.log(page)
        const data = await PosterService.GetVacancyAll(limit, page)
        setPosters(prev => prev.concat(data.data))
        setTotal(data.count)
    })

    const [fetchSettingsSite, isLoadingSettingsSite, errorSettingsSite, errorsSettingsSite] = useFetch(async () => {
      const data = await AdminService.GetSettingsSite()
      setSettingsSite(data)
    })


    useEffect(() => {
        fetchPosters()
    }, [])

    useEffect(() => {
      fetchSettingsSite()
    }, [])

    const reloadPosters = async () => {
        setPage(0)
        setPosters([])
        await fetchPosters()
    }


    const endRef = useRef<HTMLDivElement>(null);  

    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              console.log("Элемент видим на экране!");
              // Здесь можно вызвать любое действие
              // Например, загрузка данных или анимация
            }
          });
        },
        {
          root: null, // Отслеживаем относительно viewport
          threshold: 1.0, // 1.0 означает, что элемент полностью видим
        }
      );
  
      if (endRef.current) {
        observer.observe(endRef.current);
        if(total > posters.length || posters.length <= 0) {
            return
        }
        setPage(prev => prev + 1)
        fetchPosters()
      }
  
      // Очистка при размонтировании компонента
      return () => {
        if (endRef.current) {
          observer.unobserve(endRef.current);
        }
      };
    }, []);

    return (
        <Container>
            <Container className="bg-zinc-50 p-10 mb-10 rounded-lg mt-10 shadow-lg">
                <Heading>
                    Я согласен(на) на эту работу
                </Heading>
            </Container>
            <Container>
            <ScrollArea className="!bg-transparent !p-5" type="always" scrollbars="vertical" style={{height: '630px', scrollbarWidth: 'none'}}> 
            {
                posters.length ? 
                posters?.map(poster => {
                    return (
                        <Container className="bg-zinc-50 p-10 mb-10 rounded-lg shadow-lg">
                        <PosterRender poster={poster} />
                        </Container>
                    )
                })
                :
                <Spinner size={'3'} />
            }
            <Container className="end" ref={endRef}></Container>
             </ScrollArea>
            </Container>
        </Container>
    )
}